import { FormattedMessage } from 'react-intl';
import { NavLink, useSearchParams } from 'react-router';

import { Heading } from '@shieldpay/bumblebee/heading';
import PaginationMarkdown from '@shieldpay/bumblebee/markdown/pagination.md';
import { Pagination } from '@shieldpay/bumblebee/pagination';
import { TextList } from '@shieldpay/bumblebee/text-list';

import type { CursorPagination } from '@shieldpay/steamhammer-ui/api';

import { ContentsTable } from '~/components/contents-table/contents-table';
import { MdxFormatter } from '~/components/mdx-formatter/mdx-formatter';
import { ComponentPreview } from '~/components/preview/component-preview';
import { createMeta } from '~/utilities/create-meta';

export const meta = createMeta({
  id: 'hive.components.pagination.title',
});

const pagination = {
  totalCount: 20,
  nextCursor: '0',
} satisfies CursorPagination;

const mockData = [...Array(pagination.totalCount + 1).keys()]
  .slice(1)
  .map((val) => val.toString());

export const OffsetPaginationComponentPage = () => {
  const [searchParams] = useSearchParams();

  const limit = Number(searchParams.get('limit') || 5);
  const requestCursor = searchParams.get('nextCursor') || mockData[0];

  const cursorEndIndex =
    mockData.findIndex((item) => item === requestCursor) + limit;
  const nextCursor = mockData.at(cursorEndIndex) || null;

  const cursorTextList = mockData.slice(0, cursorEndIndex);

  return (
    <>
      <Heading>
        <FormattedMessage id="hive.components.pagination.title" />
      </Heading>

      <ContentsTable />

      <ComponentPreview>
        <Heading level="3" variant="headline2">
          Cursor Pagination
        </Heading>
        <TextList>
          {cursorTextList.map((item) => (
            <TextList.Item key={item}>{item}</TextList.Item>
          ))}
        </TextList>
        <Pagination
          pageSize={cursorTextList.length}
          totalCount={mockData.length}
          loadMoreTo={nextCursor ? `?nextCursor=${nextCursor}` : null}
          linkLabel="Load more"
          helpText="Showing results"
          paginationResults={({ pageSize, totalCount }) => (
            <FormattedMessage
              id="hive.components.pagination.results"
              values={{
                current: new Intl.NumberFormat().format(pageSize),
                total:
                  totalCount === 'many'
                    ? 'many'
                    : new Intl.NumberFormat().format(totalCount),
              }}
            />
          )}
          NavLink={NavLink}
        />
      </ComponentPreview>

      <MdxFormatter md={PaginationMarkdown} />
    </>
  );
};

export default OffsetPaginationComponentPage;
